module.exports = __webpack_public_path__ + "img/duo_logo.dc550c26.png";